// extracted by mini-css-extract-plugin
export default {"user-preview":"UserPreviewLarge_user-preview__HVGHJ","user-preview__inner":"UserPreviewLarge_user-preview__inner__mfnH8"};